enum ActivityBannerType {
    None = "None",
    GeneralAnonymity = "GeneralAnonymity",
    PulseSurveyPreview = "PulseSurveyPreview",
    CustomPollPreview = "CustomPollPreview",
    Recognition = "Recognition"
}

export default ActivityBannerType;